<template>
  <div style="position:relative;" class="">
    <div v-if="showNotification" class="notification">
      Poprawnie wysłano SMS.
    </div>
    <div class="user-process-modal">
      <div class="modal-insides">
        <img
          @click="closeModal"
          class="close-modal"
          src="@/icons/closemodal.svg"
          alt=""
        />

        <div class="user-process-modal-content">
          <div class="left">
            <div class="user-card">
              <div class="top-side">
                <h1>
                  {{ currentProcess ? currentProcess.user_first_name : "-" }}
                  {{ currentProcess ? currentProcess.user_last_name : "-" }}
                </h1>

                <img
                  @click="redirectToUserProfile(currentProcess.user_id)"
                  style="cursor:pointer;"
                  src="@/images/arrow.svg"
                  alt=""
                />
              </div>
              <div class="bottom-side">
                <div class="avatar-phone">
                  <div class="user-avatar">
                    <a
                      v-if="userDetails.user_profile"
                      target="_blank"
                      :href="
                        getUrl() +
                          '/api/profile/photo/' +
                          userDetails.user_profile.profile.file_path
                      "
                    >
                      <img
                        v-if="userDetails.user_profile"
                        class="img-avatar"
                        :src="
                          getUrl() +
                            '/api/profile/photo/' +
                            userDetails.user_profile.profile.file_path
                        "
                      />
                    </a>
                  </div>
                  <p>{{ currentProcess ? currentProcess.user_phone : "-" }}</p>
                </div>
                <p class="wallet">
                  {{
                    currentProcess && currentProcess.amount_in_wallet
                      ? currentProcess.amount_in_wallet + "zł"
                      : ""
                  }}
                </p>
              </div>
            </div>
            <div class="user-process-actions">
              <div class="title-and-select">
                <h1>Status</h1>
                <custom-select
                  :name="'status'"
                  v-if="
                    currentProcess.user_process_status !== 'SUCCESS' &&
                      currentProcess.user_process_status !== 'LOST'
                  "
                  @newPick="(e) => (status = e)"
                  :options="optionStatuses"
                  :prePick="chosenStatus"
                />
                <div
                  class="signal-button signal-button-success"
                  v-else-if="currentProcess.user_process_status === 'SUCCESS'"
                >
                  Sukces
                </div>
                <div
                  class="signal-button signal-button-danger"
                  v-else-if="currentProcess.user_process_status === 'LOST'"
                >
                  Stracone
                </div>
              </div>
              <div class="title-and-select">
                <h1>Wykonał/a</h1>
                <custom-select
                  :name="'admin'"
                  @newPick="(e) => (admin = e)"
                  :options="optionAdmins"
                  :prePick="chosenAdmin"
                />
              </div>
              <div class="title-and-select">
                <h1>Termin wyk.</h1>
                <div class="datepicker-wrapper">
                  <datepicker
                    class="startDate"
                    :monday-first="true"
                    :language="pl"
                    v-model="dateOfCompletion"
                    name="dateOfCompletion"
                    :placeholder="'Data wykonania'"
                  ></datepicker>
                </div>
              </div>
              <div class="title-and-select">
                <h1>Kontakt</h1>
                <custom-select
                  :name="'contact'"
                  @newPick="(e) => (contact = e)"
                  :options="optionContact"
                  :prePick="chosenContact"
                />
              </div>
            </div>
            <div class="action-buttons-grid">
              <custom-button
                @click="changeOverlayIndex"
                data-toggle="modal"
                data-target="#addNewSms"
                :size="'small'"
                :title="'Wyślij SMS'"
              />
              <custom-button
                @click="redirectToMessage(currentProcess.user_id)"
                :size="'small'"
                :title="'Wiadomość'"
              />
              <custom-button
                data-toggle="modal"
                data-target="#addNewNote"
                @click="changeOverlayIndex"
                :size="'small'"
                :title="'Dodaj notatkę'"
              />
              <custom-button
                @click="
                  redirectToPromotions(
                    currentProcess.user_id,
                    currentProcess.user_phone
                  )
                "
                :size="'small'"
                :title="'Kod rabatowy'"
              />
              <custom-button
                @click="redirectToPayment(currentProcess.user_phone)"
                :size="'small'"
                :title="'Płatności'"
              />
            </div>
            <div class="save-user-process">
              <custom-button
                @click="saveUserProcess"
                :size="'large'"
                :title="'Zapisz'"
                :gradient="true"
              />
            </div>
          </div>
          <div class="right">
            <h3 v-if="currentProcess.clv" class="ml-2">
              CLV: {{ Math.round(currentProcess.clv * 100) / 100 }}
            </h3>
            <div class="expander-wrap">
              <expander :title="'Dane użytkownika'">
                <template #content>
                  <user-process-user-table :userDetails="userDetails" />
                </template>
              </expander>
            </div>

            <div class="last-order-table-heading">
              <h1>Ostatnia zamówiona usługa</h1>
              <p @click="redirectToOrderHistory(currentProcess.user_phone)">
                historia usług
              </p>
            </div>
            <user-process-last-order-table
              @show-dates="openShowDatesModal"
              :currentProcess="currentProcess"
            />
            <div
              @click="
                redirectToNotes(
                  currentProcess.user_id,
                  currentProcess.user_phone
                )
              "
              class="last-order-table-heading note-heading"
            >
              <h1 style="cursor:pointer;">Notatki</h1>
            </div>
            <div
              v-if="currentProcess.notes && currentProcess.notes.length > 0"
              class="notes-wrapper"
            >
              <custom-note
                @newMessage="startNewMessage"
                v-for="note in currentProcess.notes"
                :key="note.id"
                :note="note"
              />
            </div>
            <div class="no-notes-info" v-else>Brak notatek</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="addNewSms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewSms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewSms">Nowy sms</h5>
            <button
              @click="hideOverlayIndex"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="sendMessage" class="addNewSmsForm">
              <div class="input-container">
                <input
                  v-model="currentProcess.user_phone"
                  id="title"
                  class="form-control"
                  type="number"
                  required
                  minlength="9"
                  maxlength="9"
                  placeholder="Numer telefonu"
                  disabled="true"
                />
              </div>
              <div class="input-container">
                <textarea
                  v-model="message"
                  id="message"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="1024"
                  placeholder="Wiadomość..."
                />
              </div>

              <button
                class="buttonm btn btn-outline-dark addNewSmsButton"
                type="submit"
              >
                Wyślij
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              @click="hideOverlayIndex"
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
              id="send-text-close"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- new profile note -->
    <div
      class="modal fade"
      id="addNewNote"
      tabindex="-1"
      role="dialog"
      aria-labelledby="c"
      data-backdrop="static"
    >
      <div
        ref="addModal"
        class="modal-dialog modal-xl note-modal-wrapper"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewNote">
              Dodawanie nowej notatki
            </h5>
            <button
              type="button"
              class="close"
              data-toggle="modal"
              :data-target="'#addNewNote'"
              @click="hideOverlayIndex"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              class="addNewTaskForm"
              @submit.prevent="addProfileNote()"
              ref="noteForm"
            >
              <div class="input-container">
                <select v-model="taskCategory" class="form-control">
                  <option value="" selected disabled>Kategoria</option>
                  <option
                    :value="category"
                    v-for="category in this.taskCategories"
                    :key="category"
                  >
                    {{ category }}
                  </option>
                </select>
              </div>
              <div class="input-container">
                <input
                  v-model="title"
                  id="title"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="255"
                  placeholder="Tytuł"
                />
              </div>
              <div class="input-container">
                <textarea
                  v-model="noteMessage"
                  id="message"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="1024"
                  placeholder="Wiadomość..."
                />
              </div>
              <select v-model="contactType" class="form-control">
                <option value="" selected disabled>Sposób konktaktu</option>
                <option
                  :value="contactType"
                  v-for="contactType in this.contactTypes"
                  :key="contactType"
                >
                  <span v-if="contactType === 'PHONE'">Telefon odebrany</span>
                  <span v-if="contactType === 'PHONE_OUT'"
                    >Telefon wykonany</span
                  >
                  <span v-if="contactType === 'EMAIL'">Email</span>
                  <span v-if="contactType === 'CHAT'">Czat</span>
                  <span v-if="contactType === 'LIST'">List</span>
                </option>
              </select>
              <label>
                <input type="file" @change="getImage($event)" id="file-input" />
              </label>
              <button
                class="buttonm btn btn-outline-dark addNoteBtn"
                type="submit"
                ref="addNoteBtn"
              >
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              ref="addNoteBtnClose"
              data-toggle="modal"
              id="addNoteBtnClose"
              :data-target="'#addNewNote'"
              @click="hideOverlayIndex"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- new profile note  -->
    <!-- new message to profile note  -->
    <div
      class="modal fade"
      id="addNewTaskMessage"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewTaskMessage"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewTaskMessage">
              Dodawanie nowej wiadomości
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideOverlayIndex"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="addNewTaskForm" @submit.prevent="addNewTaskMessage()">
              <div class="input-container">
                <label>Wiadomość</label>
                <textarea
                  v-model="newTaskMessage"
                  id="title"
                  class="form-control mb-4"
                  type="text"
                  minlength="1"
                  placeholder="Nowa wiadomość"
                />

                <input
                  type="file"
                  @change="getImage($event)"
                  id="message-file-input"
                />
              </div>
              <button
                class="addMsgBtn buttonm btn btn-outline-dark"
                type="submit"
              >
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              id="close-message-add-modal"
              class="btn btn-outline-dark"
              data-dismiss="modal"
              @click="hideOverlayIndex"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- new message to profile note  -->

    <!-- dates modal  -->
    <div
      class="modal fade"
      id="listAllDatesModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="listAllDatesModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="listAllDatesModal">
              Lista terminów
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideOverlayIndex"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="currentProcess.last_order" class="modal-body">
            <p v-for="date in currentProcess.last_order.period" :key="date">
              {{ date }}<br />
            </p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              id="close-message-add-modal"
              class="btn btn-outline-dark"
              data-dismiss="modal"
              @click="hideOverlayIndex"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- dates modal  -->
    <button
      id="open-message-modal"
      data-toggle="modal"
      data-target="#addNewTaskMessage"
      style="display:none"
    ></button>
    <div id="user-process-overlay" class="overlay"></div>
    <button
      id="open-dates-modal"
      data-toggle="modal"
      data-target="#listAllDatesModal"
      style="display:none"
    ></button>
    <div id="user-process-overlay" class="overlay"></div>
  </div>
</template>
<script>
import CustomSelect from "./CustomSelect.vue";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
import CustomButton from "./CustomButton.vue";
import axios from "@/axios";
import Expander from "./Expander.vue";
import { URL } from "@/axios";
import UserProcessUserTable from "./UserProcessUserTable.vue";
import UserProcessLastOrderTable from "./UserProcessLastOrderTable.vue";
import CustomNote from "@/components/CustomNote";
export default {
  components: {
    CustomSelect,
    Datepicker,
    CustomButton,
    Expander,
    UserProcessUserTable,
    UserProcessLastOrderTable,
    CustomNote,
  },
  props: ["data"],
  emits: ["close-modal", "refresh"],
  data() {
    return {
      status: this.$store.getters.getCurrentProcess.user_process_status,
      admin: this.$store.getters.getCurrentProcess.user_process_admin,
      dateOfCompletion: this.data.user_process_completion_date,
      contact: this.$store.getters.getCurrentProcess.user_process_contact_type,
      pl: pl,
      message: "",
      taskCategories: [],
      contactTypes: [],
      noteMessage: "",
      contactType: "",
      newTaskMessage: "",
      taskCategory: "",
      title: "",
      file: "",
      currentNoteId: "",
      selectOpened: [false, false, false],
      showNotification: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("getUserById", {
      userId: this.currentProcess.user_id,
    });
    axios.get(`/api/profileNote/categories`).then((response) => {
      this.taskCategories = response.data;
    });
    axios.get(`/api/profileNote/contactTypes`).then((response) => {
      this.contactTypes = response.data;
      [this.contactTypes[1], this.contactTypes[4]] = [
        this.contactTypes[4],
        this.contactTypes[1],
      ];
    });
  },
  methods: {
    openShowDatesModal() {
      let btn = window.document.getElementById("open-dates-modal");
      if (btn) btn.click();
      this.changeOverlayIndex();
    },
    startNewMessage(id) {
      this.currentNoteId = id;
      let btn = window.document.getElementById("open-message-modal");
      if (btn) btn.click();
      this.changeOverlayIndex();
    },
    getUrl() {
      return URL;
    },
    getImage(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    addNewTaskMessage() {
      if (!this.newTaskMessage && !this.file) {
        return this.$notify({
          group: "error",
          text:
            "Wiadomośc nie może być pusta. Musi zawierać teks lub załącznik",
        });
      }
      const url = `/api/profileNoteMessage/${this.currentNoteId}`;

      const body = new FormData();
      body.append("message", this.newTaskMessage);
      body.append("file", this.file);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano wiadomość",
            });
            this.refetchProcess();
            this.newTaskMessage = "";
            this.file = null;
            setTimeout(() => {
              const btnToClose = document.getElementById(
                "close-message-add-modal"
              );
              if (btnToClose) {
                btnToClose.click();
              }
            }, 500);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się dodać wiadomości",
          });
        });
    },
    sendMessage() {
      if (this.message !== "") {
        axios
          .post(`api/smsFromAdmin/${this.currentProcess.user_phone}`, {
            message: this.message,
          })
          .then(() => {
            this.showNotification = true;
            setTimeout(() => {
              const btnToClose = document.getElementById("send-text-close");
              if (btnToClose) {
                btnToClose.click();
              }
            }, 500);
            setTimeout(() => {
              this.showNotification = false;
            }, 3000);
          })
          .catch((err) => {
            if (err.response.data.error === "not_found_user") {
              this.$notify({
                group: "error",
                text: "Nie istnieje użytkownik o podanym numerze",
              });
            } else {
              this.$notify({
                group: "error",
                text: "Nie udało się wysłać wiadomości",
              });
            }
          });
      } else {
        this.$notify({
          group: "error",
          text: "Wiadomośc jest pusta ",
        });
      }
    },
    addProfileNote() {
      const url = `/api/profileNote`;
      if (!this.taskCategory) {
        this.$notify({
          group: "error",
          text: "Wybierz kategorię",
        });
        return;
      }

      const body = new FormData();
      body.append("message", this.noteMessage);
      body.append("title", this.title);
      body.append("category", this.taskCategory);
      body.append("file", this.file);
      body.append("associated_user", this.currentProcess.user_id);
      body.append("contact_type", this.contactType);
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano notatke",
            });
            (this.title = ""),
              (this.message = ""),
              (this.taskCategory = ""),
              (this.userPhone = ""),
              (this.contactType = "");
            this.category = "";
            this.file = null;
            (this.associated_user = null), (this.title = "");
            this.refetchProcess();
            setTimeout(() => {
              const btnToClose = document.getElementById("addNoteBtnClose");
              if (btnToClose) {
                btnToClose.click();
              }
            }, 500);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    refetchProcess() {
      this.$store.dispatch("fetchOneProcess", this.currentProcess.id);
    },
    changeOverlayIndex() {
      let overlay = window.document.getElementById("user-process-overlay");
      overlay.style.zIndex = "99999991";
    },
    hideOverlayIndex() {
      let overlay = window.document.getElementById("user-process-overlay");
      overlay.style.zIndex = "9999998";
    },
    closeModal() {
      this.$emit("close-modal");
    },
    redirectToOrderHistory(phone) {
      const routeData = this.$router.resolve(`/history?search=${phone}`);
      window.open(routeData.href, "_blank");
    },
    redirectToUserProfile(id) {
      const routeData = this.$router.resolve(`/users/id/${id}`);
      window.open(routeData.href, "_blank");
    },
    redirectToMessage(id) {
      const routeData = this.$router.resolve(`/chat/${id}`);
      window.open(routeData.href, "_blank");
    },
    redirectToNotes(id, phone) {
      const routeData = this.$router.resolve(`/notes/${id}?id=${phone}`);
      window.open(routeData.href, "_blank");
    },
    redirectToPromotions(id, phone) {
      const routeData = this.$router.resolve(`/promotions/${id}?id=${phone}`);
      window.open(routeData.href, "_blank");
    },
    redirectToPayment(phone) {
      const routeData = this.$router.resolve(`/payments-list?search=${phone}`);
      window.open(routeData.href, "_blank");
    },
    showCorrectTitle(title) {
      if (title === "WAITING_FOR_CONTACT") return "Do zrobienia";
      if (title === "PENDING_ACTION") return "Zrobione";
      if (title === "SUCCESS") return "Sukces";
      if (title === "LOST") return "Stracone";
      if (title === "PHONE") return "Telefon";
      if (title === "NONE") return "Brak";
      return title;
    },
    async saveUserProcess() {
      const obj = {
        id: this.currentProcess.id,
        status: this.status,
        contact_type: this.contact,
        admin_id: this.admin,
        completion_date: this.dateOfCompletion,
      };
      await this.$store.dispatch("editProcess", obj);
      this.$emit("refresh");
    },
  },

  computed: {
    chosenStatus() {
      return this.$store.getters.getCurrentProcess.user_process_status;
    },
    chosenContact() {
      return this.$store.getters.getCurrentProcess.user_process_contact_type;
    },
    chosenAdmin() {
      return this.$store.getters.getCurrentProcess.user_process_admin;
    },
    currentProcess() {
      return this.$store.getters.getCurrentProcess;
    },
    allSettings() {
      return this.$store.getters.getProcessSettings;
    },
    userDetails() {
      return this.$store.getters.getUserById;
    },
    optionStatuses() {
      let tmp = [];
      this.allSettings.statuses.forEach((status) => {
        if (status !== "SUCCESS") {
          tmp.push({
            value: status,
            name: this.showCorrectTitle(status),
            shortName: this.showCorrectTitle(status),
          });
        }
      });
      return tmp;
    },
    optionContact() {
      let tmp = [];
      this.allSettings.contact_types.forEach((status) => {
        tmp.push({
          value: status,
          name: this.showCorrectTitle(status),
          shortName: this.showCorrectTitle(status),
        });
      });
      return tmp;
    },
    optionAdmins() {
      let tmp = [];
      this.allSettings.admins.forEach((admin) => {
        tmp.push({
          value: admin.id,
          name: this.showCorrectTitle(admin.login),
          shortName: this.showCorrectTitle(admin.login),
          admin: true,
        });
      });
      return tmp;
    },
  },
};
</script>
<style src="./user-process-modal.css" scoped></style>
